import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative flex h-full flex-col" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex flex-1 flex-col break-words pt-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_6 = {
  key: 0,
  class: "stamped-fa stamped-fa-star",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 1,
  class: "stamped-fa stamped-fa-star-half-o",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 2,
  class: "stamped-fa stamped-fa-star-o",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "text-12 font-medium" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "text-12 font-normal opacity-50"
}
const _hoisted_12 = { class: "mt-auto" }
const _hoisted_13 = { class: "pr-8 text-12 text-black-400" }
const _hoisted_14 = { class: "text-14 font-medium" }
const _hoisted_15 = {
  key: 0,
  class: "pr-8 text-12 text-black-400"
}
const _hoisted_16 = { class: "text-14 font-medium" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["name", "value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["href", "disabled"]
const _hoisted_22 = ["href", "disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_video = _resolveComponent("v-video")
  const _component_v_image = _resolveComponent("v-image")
  const _component_grid_item_tags = _resolveComponent("grid-item-tags")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: $options.productUrl,
        onClick: _cache[0] || (_cache[0] = $event => ($options.saveProductGridIndex($props.productIndex)))
      }, [
        ($options.featuredMedia?.media_type === 'video')
          ? (_openBlock(), _createBlock(_component_v_video, {
              key: 0,
              autoplay: "",
              source: $options.featuredMedia.sources[0].url,
              "source-mobile": $options.featuredMedia.sources[0].url,
              class: "aspect-grid-item max-h-[40rem] w-full object-cover object-top"
            }, null, 8, ["source", "source-mobile"]))
          : (_openBlock(), _createBlock(_component_v_image, {
              key: 1,
              lazyloaded: $props.lazyloadImages,
              source: $options.featuredMedia.src || $props.product.image,
              alt: $options.featuredMedia.alt,
              class: "aspect-grid-item max-h-[40rem] w-full object-cover object-top"
            }, null, 8, ["lazyloaded", "source", "alt"]))
      ], 8, _hoisted_3),
      ($props.product.tags)
        ? (_openBlock(), _createBlock(_component_grid_item_tags, {
            key: 0,
            product: {
          available: $props.product.available,
          title: $props.product.title,
          price: $props.product.price,
          compare_at_price: $props.product.compare_at_price,
          tags: $props.product.tags,
        },
            "collection-kit-discount-percentage": $options.discountPercentage
          }, null, 8, ["product", "collection-kit-discount-percentage"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        ($props.product.stamped_reviews_rating_count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                style: _normalizeStyle({color: $data.stampedStarColor})
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: star }, [
                    (star <= $options.fullStars)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                      : (star === $options.fullStars + 1 && $options.hasHalfStar)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                        : (_openBlock(), _createElementBlock("i", _hoisted_8))
                  ], 64))
                }), 64))
              ], 4),
              _createElementVNode("span", _hoisted_9, "(" + _toDisplayString($props.product.stamped_reviews_rating_count) + ")", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: $options.productUrl,
          class: "flex flex-col gap-4 text-16 font-medium",
          onClick: _cache[1] || (_cache[1] = $event => ($options.saveProductGridIndex($props.productIndex)))
        }, [
          _createTextVNode(_toDisplayString($props.product.title) + " ", 1),
          ($props.product.subheadline)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($props.product.subheadline), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_10),
        _createElementVNode("p", _hoisted_12, [
          ($options.giftCardDiscountValue)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("del", _hoisted_13, _toDisplayString($options.price), 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString($options.giftCardDiscountPrice), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($options.compareAtPrice > $options.price)
                  ? (_openBlock(), _createElementBlock("del", _hoisted_15, _toDisplayString($options.compareAtPrice), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_16, _toDisplayString($options.price), 1)
              ], 64))
        ])
      ]),
      ($data.isQuickAddEnabled && $options.productType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!$options.productType.includes('starter') && $options.productType !== 'gift cards')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  name: "add_to_cart",
                  class: "mt-auto pt-12",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.throttledQuickAdd($event)), ["prevent"]))
                }, [
                  ($options.backInStockEligible)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-xsmall btn-accent btn-mail__before capitalize",
                        onClick: _cache[2] || (_cache[2] = $event => ($options.klaviyoRedirect()))
                      }, _toDisplayString($data.product_back_in_stock_signup_label), 1))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        name: "add",
                        class: "btn-xsmall btn-accent btn-plus__before capitalize",
                        disabled: !$props.product.available
                      }, _toDisplayString($data.locale.add_to_cart), 9, _hoisted_17)),
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "id",
                    value: $props.product.first_available_variant_id
                  }, null, 8, _hoisted_18),
                  ($props.product?.deliverable_at)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "hidden",
                        name: `properties[${$data.locale.deliverable_at}]`,
                        value: $props.product.deliverable_at
                      }, null, 8, _hoisted_19))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "properties[_KitOptionalProductStandardPrice]",
                    value: $props.product.price
                  }, null, 8, _hoisted_20)
                ], 32))
              : ($options.productType.includes('starter'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: $options.productUrl,
                    class: "btn-xsmall btn-accent btn-arrow__before mt-auto self-start pt-12 text-center capitalize",
                    disabled: !$props.product.available
                  }, _toDisplayString($data.locale.create_new_set), 9, _hoisted_21))
                : ($options.productType === 'gift cards')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: $options.productUrl,
                      class: "btn-xsmall btn-accent btn-arrow__before mt-auto self-start pt-12 text-center capitalize",
                      disabled: !$props.product.available
                    }, _toDisplayString($data.locale.configure_gift_card), 9, _hoisted_22))
                  : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}